import React, { lazy, Suspense } from "react";
import axios from "axios";
import { isMobile } from "react-device-detect";
//import "@scuf/common/honeywell/theme.css";
//import "@scuf/common/honeywell-dark/theme.css";

import { Header, Notification, Button, Input, Icon, Table, Checkbox, Statistic, Grid } from "@scuf/common";
import Votar from "./Components/Votar";
import MyIFrame from "./Components/MyIFrame";
import 'react-toastify/dist/ReactToastify.css';
import './toast-notification-wrap.css'

const ReactToastify = require('react-toastify');

const config = require("./config.json");
const API = config.api_login
const apiKey = config.authorization;
const headers = { 'authorization': apiKey }
const Titulo = config.Titulo.replace("Comite", "Comité");


function Tema() {

    var Theme
    if (localStorage.getItem('checklistTheme') === 'true')
        Theme = lazy(() => import("./Components/Theme_Dark"))
    else
        Theme = lazy(() => import("./Components/Theme_Light"))


    return <Suspense fallback={null}>
        <Theme />
    </Suspense>


}


const ToastNotification = ({ closeToast, Texto, Detalle }) => (
    <Notification
        className="toast-notification"
        severity="critical"
        onCloseClick={closeToast}
        hasIcon={true}
        title={Texto}
        detailsText={Detalle}
        onDetailsClick={() => { }} //{() => alert('Debie ingresar todos los datos para continuar')}
    />

)




export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tema: localStorage.getItem('checklistTheme'),
            hidden: "hidden",
            hiddeRUT: "",
            hiddePIN: "hidden",
            RUT: "",
            PIN: "PIN",
            candidatos: [],
            logueado: 0,
            isLoading: false,
            dato1: "-",
            dato2: "-",
            dato3: "-",
            dato4: 0,
            dato5: "-",
            dato6: 0,
            dato7: 0,
            reporte: false,
            JsonString: []
        };
        this.onButtonClick = this.onButtonClick.bind(this);
        this.onButton2Click = this.onButton2Click.bind(this);
    }

    onButtonClick() {

        var items;
        this.setState({ isLoading: true });
        if (this.state.RUT.length < 7)
            this.setState({ logueado: -1, isLoading: false })
        else
            try {
                axios.post(`${API}`,
                    {
                        "RUT": this.state.RUT
                    },
                    { headers: headers })
                    .then((res) => {
                        items = res.data
                        this.setState({
                            reporte: items[0].dato2 === 'Usted ya votó' && items[0].dato4 ? true : false,
                            candidatos: items,
                            dato1: items[0].dato1,
                            dato2: items[0].dato2,
                            dato3: items[0].dato3,
                            dato4: items[0].dato4,
                            dato5: items[0].dato5,
                            dato6: items[0].dato6,
                            dato7: items[0].dato7,
                            isLoading: false
                        });

                    });


            } catch (e) {
                this.setState({
                    logueado: -2,
                    isLoading: false,
                    JsonString: e
                })
            }
    }


    onButton2Click() {
        if (this.state.dato3 == this.state.PIN) {
            this.setState({
                logueado: 1,
                isLoading: false,
            })
        } else
            this.setState({
                logueado: -10,
                dato1: "PIN Inválido",
                isLoading: false,
            })
    }



    handleOnChangeTheme = (checked) => {
        localStorage.setItem('checklistTheme', checked.toString())
        window.location.reload();
    }


    componentDidMount() {
        setTimeout(function () {
            this.setState({ hidden: "" });
        }.bind(this), 75)
    }



    render() {

        if (this.state.logueado === 1 && this.state.reporte === true) {
            return (
                <MyIFrame />
            )
        } else if (this.state.logueado === 1) {
            return (
                <Votar idEleccion={this.state.dato6} NVotos={this.state.dato7} RUT={this.state.RUT} Email={this.state.dato5} Reporte={this.state.dato4} candidatos={this.state.candidatos} />
            )
        }
        else
            return (
                <div className={this.state.hidden}>
                    {/*{JSON.stringify(this.state.candidatos)}{<br />}*/}
                    {/*{JSON.stringify(this.state.dato3)}{<br />}*/}
                    {/*{JSON.stringify(this.state.dato4)}{<br />}*/}
                    {/*{JSON.stringify(this.state.logueado)}*/}

                    <Tema onLoaded={this.handleLoaded} />
                    <Header title="Elecciones" menu={false}>
                    </Header>

                    <div className={isMobile ? "" : "PC"}>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={4} sWidth={12}>
                                    <Statistic value="" fluid={true} />
                                </Grid.Column>
                                <Grid.Column width={4} sWidth={12}>
                                    <Statistic value={Titulo} fluid={true} />
                                    {/*<Statistic value="Honeywell Chile" fluid={true} />*/}
                                </Grid.Column>
                                <Grid.Column width={4} sWidth={12}>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>


                        <Table className={isMobile ? "bottom" : ""}>
                            <Table.Body>
                                <Table.Row>
                                    <Table.Cell textAlign="center">
                                        <div className={!isNaN(this.state.dato3) ? "hidden" : ""}>
                                            <Input key={"1"} fluid={true} disabled={this.state.isLoading} placeholder="Ingrese su RUT o EID" value={this.state.RUT} onChange={(value) => this.setState({ RUT: value })} />
                                            <div style={{ paddingTop: 10 }}>
                                                <Button key={"1"} className="fullancho" disabled={this.state.isLoading} loading={this.state.isLoading} fluid={true} icon={<Icon name="unlock" root="common" />} content="Solicitar Acceso" onClick={this.onButtonClick} />
                                            </div>
                                        </div>
                                        <div className={!isNaN(this.state.dato3) ? "" : "hidden"}>
                                            <Input key={"2"} fluid={true} disabled={this.state.isLoading} placeholder="Ingrese el PIN enviado a su mail" value={this.state.PIN} onChange={(value) => this.setState({ PIN: value })} type={"number"} />
                                            <div style={{ paddingTop: 10 }}>
                                                <Button className="fullancho" disabled={this.state.isLoading} loading={this.state.isLoading} fluid={true} icon={<Icon name="user" root="common" />} content="Ingresar" onClick={this.onButton2Click} />
                                            </div>
                                        </div>
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell textAlign="right">
                                        <Checkbox label={this.state.tema === 'true' ? 'Dark' : 'Light'} toggle={true} checked={this.state.tema === 'true' ? true : false}
                                            onChange={(checked) => this.handleOnChangeTheme(checked)} />
                                    </Table.Cell>
                                </Table.Row>
                            </Table.Body>
                        </Table>
                    </div>

                    {
                        (() => {
                            switch (this.state.dato1) {
                                case "Error":
                                    ReactToastify.toast(<ToastNotification Texto={this.state.dato2} Detalle={this.state.reporte ? "Solo puede ver el reporte" : "No puede votar"} closeToast={true} />);
                                    this.setState({ dato1: "" })
                                    break;
                                case "PIN Inválido":
                                    ReactToastify.toast(<ToastNotification Texto={"PIN Inválido"} Detalle={"Ingrese el PIN"} closeToast={true} />);
                                    this.setState({ dato1: "" })
                                    break;
                                default:
                                    return null;
                            }
                        })()
                    }


                    <div>
                        <ReactToastify.ToastContainer
                            hideProgressBar={false}
                            closeOnClick={false}
                            closeButton={false}
                            newestOnTop={true}
                            position="bottom-right"
                            autoClose={2500}
                            toastClassName="toast-notification-wrap"
                        />
                    </div>


                    {/*<Footer className="bottom" copyrightText={"© " + new Date().getFullYear() + " Honeywell Chile"}>*/}
                    {/*    <Footer.Item href="#">Terms & Conditions</Footer.Item>*/}
                    {/*    <Footer.Item href="#">Privacy Policy</Footer.Item>*/}
                    {/*</Footer>*/}
                </div >

            );
    }

    notify() {
        ReactToastify.toast(<ToastNotification closeToast={true} />)
    }

}
